module.exports = "/_next/static/images/6ea397e2b1891f85c8d00af79db17ed7-qr-to-app-v1.svg";